import { Phone, Clock, MapPin } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import { Reveal } from "./Reveal";
import { STORES, PHONE_DISPLAY, PHONE_TEL, WHATSAPP_URL } from "@/lib/svenData";

export const VisitUs = () => (
  <section id="visit" data-testid="visit-us-section" className="bg-[#faf8f5] py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <p className="overline-label mb-5">Visit Us</p>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-medium text-[#141414] mb-14">
          Two ateliers, <em className="font-accent text-[#99732b]">one road.</em>
        </h2>
      </Reveal>

      <div className="grid lg:grid-cols-2 gap-8">
        {STORES.map((store, i) => (
          <Reveal key={store.id} delay={0.1 * i}>
            <article data-testid={`store-card-${store.id}`} className="border border-[#e7e2da] bg-white hover:border-[#c5a059]/60 transition-colors duration-500">
              <iframe
                data-testid={`store-map-${store.id}`}
                title={`Map — Sven Suits ${store.name}`}
                src={`https://www.google.com/maps?q=${encodeURIComponent(store.mapQuery)}&output=embed`}
                className="w-full h-64 border-0 grayscale-[35%] hover:grayscale-0 transition-all duration-700"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
              <div className="p-8">
                <h3 className="font-display text-xl text-[#141414]">{store.name}</h3>
                <div className="mt-4 space-y-3">
                  <p className="flex items-start gap-3 text-sm font-light leading-relaxed text-[#57534e]">
                    <MapPin size={15} className="text-[#c5a059] shrink-0 mt-0.5" />
                    {store.address}
                  </p>
                  <p className="flex items-center gap-3 text-sm font-light text-[#57534e]">
                    <Clock size={15} className="text-[#c5a059] shrink-0" />
                    {store.hours}
                  </p>
                </div>
                <div className="mt-6 flex flex-wrap gap-3">
                  <a
                    data-testid={`store-call-${store.id}`}
                    href={PHONE_TEL}
                    className="inline-flex items-center gap-2 px-5 py-2.5 bg-[#0b0b0c] text-[#faf8f5] font-mono-ov text-[10px] tracking-[0.15em] uppercase rounded-full hover:bg-[#c5a059] hover:text-[#0b0b0c] transition-colors duration-300"
                  >
                    <Phone size={12} /> {PHONE_DISPLAY}
                  </a>
                  <a
                    data-testid={`store-whatsapp-${store.id}`}
                    href={`${WHATSAPP_URL}?text=${encodeURIComponent(`Hello Sven Suits! I'd like to visit your ${store.name}.`)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-5 py-2.5 border border-[#25D366]/50 text-[#128C4A] font-mono-ov text-[10px] tracking-[0.15em] uppercase rounded-full hover:bg-[#25D366] hover:text-[#0b0b0c] hover:border-[#25D366] transition-colors duration-300"
                  >
                    <FaWhatsapp size={13} /> WhatsApp
                  </a>
                </div>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
